<body class="home">
     
    <div id="page" class="page">
      <div #services></div>
       <!-- site header html start  -->
       <app-smart-header></app-smart-header>
       <main id="content" class="site-main">
        <section class="service-inner-page inner-page-wrap">
           <!-- ***Inner Banner html start form here*** -->
           <div class="inner-banner-wrap">
              <div class="inner-baner-container" style="background-image: url(https://voyjaleas-website.sebtec12.workers.dev/voyjaleas-camisa-espalda.png);">
                 <div class="container">
                    <div class="inner-banner-content">
                       <h1 class="page-title" style="margin-top: 2rem;">Servicios</h1>
                    </div>
                 </div>
              </div>
           </div>
           <!-- ***Inner Banner html end here*** -->
           <!-- ***about section html start form here*** -->
           <div class="inner-career-detail-wrap">
            <div class="container">
               <div class="row">
                  <div class="col-lg-8 offset-lg-2 text-sm-center">
                     <div class="section-heading">
                        <h5 class="sub-title">Te ayudaremos a cumplir tu meta</h5>
                        <h2 class="section-title">COMIENZA AHORA</h2>
                        <p>Te explicamos los pasos que seguiremos para comenzar a ayudarte en tu objetivo y en tus planes. Si tenés preguntas no dudes en contactarnos.</p>
                     </div>
                  </div>
               </div>
               <div class="row">
                  <div class="col-md-5">
                     <figure class="career-detail-image">
                        <img src="https://voyjaleas-website.sebtec12.workers.dev/servicios-legal-1.png">
                     </figure>
                  </div>
                  <div class="col-md-7">
                     <div class="tab-section">
                        <div class="tab-container">
                           <div class="responsive-tabs">
                              <ul class="nav nav-tabs" role="tablist">
                                 <li class="nav-item">
                                    <a id="tab-A" href="#pane-A" class="nav-link active" data-bs-toggle="tab" role="tab">
                                       CONTACTO INICIAL
                                    </a>
                                 </li>
                                 <li class="nav-item">
                                    <a id="tab-B" href="#pane-B" class="nav-link" data-bs-toggle="tab" role="tab">
                                       SERVICIOS
                                    </a>
                                 </li>
                                 <li class="nav-item">
                                    <a id="tab-C" href="#pane-C" class="nav-link" data-bs-toggle="tab" role="tab">
                                       ASISTENCIA
                                    </a>
                                 </li>
                              </ul>

                              <div id="nav-tab-content" class="tab-content" role="tablist">
                                 <div id="pane-A" class="card tab-pane fade show active" role="tabpanel" aria-labelledby="tab-A">
                                    <div class="card-header" role="tab" id="heading-A">
                                       <h5 class="mb-0">
                                          <a data-bs-toggle="collapse" href="#collapse-A" aria-expanded="true" aria-controls="collapse-A">
                                             CONTACTO INICIAL
                                          </a>
                                       </h5>
                                    </div>
                                    <div id="collapse-A" class="collapse show" data-bs-parent="#nav-tab-content" role="tabpanel"
                                         aria-labelledby="heading-A">
                                       <div class="card-body">
                                          <h4>VIDEOLLAMADA</h4>
                                          <p>Mediante una videollamada de 30 minutos conoceremos los detalles de tu caso y tus planes para saber cómo comenzar a ayudarte.</p>
                                          <p>Cada caso es diferente por lo que necesitamos entender cuánta ayuda podrás necesitar.</p>
                                          <p>Ya sea que recientemente te has propuesto salir del país o bien si ya tienes tus planes y trámites en proceso, estaremos a tu lado para solucionar tu dudas, ofrecerte asesoría legal, conseguirte un seguro médico y más!</p>
                                       </div>
                                    </div>
                                 </div>

                                 <div id="pane-B" class="card tab-pane fade" role="tabpanel" aria-labelledby="tab-B">
                                     <div class="card-header" role="tab" id="heading-B">
                                         <h5 class="mb-0">
                                          <a class="collapsed" data-bs-toggle="collapse" href="#collapse-B" aria-expanded="false" aria-controls="collapse-B">
                                             SERVICIOS
                                          </a>
                                       </h5>
                                    </div>
                                    <div id="collapse-B" class="collapse" data-bs-parent="#nav-tab-content" role="tabpanel"
                                         aria-labelledby="heading-B">
                                       <div class="card-body">
                                          <h4>SERVICIOS PERSONALIZADOS</h4>
                                          <p>
                                             Al elegir nuestra consultoría, usted accederá a un abanico de servicios diseñados para hacer su proceso lo más fluido y claro posible.
                                          </p>
                                          <h5>Nuestros servicios incluyen:</h5>
                                          <p>Planificación de Viajes: Organizamos con vos todos los preparativos personalizados para que su experiencia de viaje sea inolvidable, desde la elección de destinos hasta la reserva de alojamientos y transporte.</p>
                                          <p>Gestión de Visados y Documentación: Le asistimos en la compleja tramitación de visados y otros documentos necesarios para su estancia en Europa, asegurando que cumple con todos los requisitos legales sin complicaciones.</p>
                                          <p>Programas de Estudio y Becas: Ofrecemos orientación detallada sobre las opciones de estudio, incluyendo la elección de instituciones académicas y la solicitud de becas para maximizar sus oportunidades educativas.</p>
                                          <p>Oportunidades Laborales: Le ayudamos a navegar el mercado laboral europeo con asesoramiento sobre búsqueda de empleo, redacción de CVs y preparación para entrevistas para aumentar sus posibilidades de éxito profesional.</p>
                                          <p>Alojamiento y Establecimiento: Facilitamos la búsqueda de un hogar en Europa, proporcionando opciones que se ajusten a sus necesidades y presupuesto.</p>
                                          <p>Soporte Continuo: Una vez en Europa, seguimos a su lado con asistencia continua para asegurar que su adaptación al nuevo entorno sea lo más suave posible.</p>
                                          <p>En VoyJaleas, estamos comprometidos con hacer de su aventura europea una realidad exitosa y gratificante. Contáctenos hoy para empezar a planificar su futuro en Europa.</p>
                                       </div>
                                    </div>
                                 </div>

                                 <div id="pane-C" class="card tab-pane fade" role="tabpanel" aria-labelledby="tab-C">
                                    <div class="card-header" role="tab" id="heading-C">
                                       <h5 class="mb-0">
                                          <a data-bs-toggle="collapse" href="#collapse-C" aria-expanded="true" aria-controls="collapse-C">
                                             ASISTENCIA
                                          </a>
                                       </h5>
                                    </div>
                                    <div id="collapse-C" class="collapse" data-bs-parent="#nav-tab-content" role="tabpanel"
                                         aria-labelledby="heading-C">
                                       <div class="card-body">
                                          <h4>CONSULTORÍA Y ASISTENCIA
                                          </h4>
                                          <p>
                                             Ofrecemos un servicio integral, utilizando herramientas digitales avanzadas para garantizar que tu transición sea fluida y libre de estrés. A través de nuestra webapp, videollamadas, email y un grupo exclusivo de WhatsApp, estamos equipados para asistirle en cada paso de su viaje.
                                          </p>
                                          <h5>Explore nuestros servicios digitales:</h5>
                                          <p>Webapp Personalizada: Acceda a nuestra plataforma en línea donde podrá gestionar todos los aspectos de su viaje y estancia en Europa. Desde aquí, puede consultar recursos, realizar trámites y mantenerse informado de las últimas novedades y requisitos legales.</p>
                                          <p>Videollamadas Programadas: Programe sesiones de asesoramiento y soporte con nuestros expertos, quienes le proporcionarán orientación detallada y respuestas en tiempo real a todas sus inquietudes.</p>
                                          <p>Comunicación Continua por Email: Manténgase en contacto constante con nuestro equipo a través de emails. Ya sea para resolver dudas puntuales o recibir actualizaciones importantes, estamos a un correo de distancia.</p>
                                          <p>Grupo de WhatsApp Dedicado: Únase a nuestra comunidad en WhatsApp, donde podrá interactuar con otros clientes y recibir asistencia colectiva. Este espacio está diseñado para compartir experiencias, consejos y recibir soporte grupal de manera rápida y eficiente.</p>
                                          <p>En VoyJaleas, utilizamos la tecnología para acercarnos más a usted, adaptándonos a sus necesidades y horarios para proporcionar una experiencia personalizada y accesible. Contáctenos hoy mismo para descubrir cómo podemos ayudarle a hacer realidad su sueño europeo con el apoyo continuo que merece.</p>
                                       </div>
                                    </div>
                                 </div>
                             </div>
                           </div>
                        </div>
                     </div>
                  </div>

                  <!-- <div class="col-lg-4">
                     <div class="job-description primary-bg text-center">
                        <h4>SUMMARY</h4>
                        <ul>
                           <li>
                              <span>Post :</span>
                              <h5>TRAVEL GUIDE</h5>
                           </li>
                           <li>
                              <span>Time :</span>
                              <h5>FULL TIME / PART TIME</h5>
                           </li>
                           <li>
                              <span>Salary :</span>
                              <h5>NEGOTIABLE</h5>
                           </li>
                           <li>
                              <span>No. of Vacancy :</span>
                              <h5>8</h5>
                           </li>
                        </ul>
                     </div>
                  </div>
                  <div class="col-lg-4">
                     <div class="job-description bg-light-grey">
                        <h4>HOW TO APPLY</h4>
                        <ul>
                           <li>
                              <i aria-hidden="true" class="fas fa-dot-circle"></i>
                              Veniam suspen disse volup.
                           </li>
                           <li>
                              <i aria-hidden="true" class="fas fa-dot-circle"></i>
                              Etiam porta repellendus nihil.
                           </li>
                           <li>
                              <i aria-hidden="true" class="fas fa-dot-circle"></i>
                              Ornare ornare tias torquent.>
                           </li>
                           <li>
                              <i aria-hidden="true" class="fas fa-dot-circle"></i>
                              Adip nostrum fames porta.
                           </li>
                        </ul>
                     </div>
                  </div>
                  <div class="col-lg-4">
                     <div class="job-description bg-image text-center">
                        <div class="overlay"></div>
                        <h3>SEND US C.V</h3>
                        <p>Convallis neque voluptas varius erat do bibendum, corrupti!</p>
                        <a href="mailto:info@company.com">
                           <i aria-hidden="true" class="fas fa-envelope-open-text"></i>
                           info@company.com
                        </a>
                        <a href="contact.html" class="round-btn">Contact Us</a>
                     </div>
                  </div> -->

               </div>
            </div>
         </div>



           <div class="inner-service-wrap">
              <div class="container">
                <div class="row">
                    <div class="col-lg-8 offset-lg-2 text-sm-center">
                       <div class="section-heading">
                          <h5 class="sub-title">CATEGORÍAS DE</h5>
                          <h2 class="section-title">SERVICIOS</h2>
                          <p>Somos un puente hacia nuevas oportunidades en Europa. Nos dedicamos a facilitar tu transición hacia una experiencia enriquecedora, ya sea para viajar, estudiar o trabajar en el continente europeo.</p>
                       </div>
                    </div>
                 </div>

                 <div class="row">
                    <div class="col-lg-4 col-sm-6">
                       <div class="icon-box bg-img-box" style="background-image: url(https://imagedelivery.net/_h1KjDl91qmiTNUGHVGxKQ/85808a7d-0f8b-45c1-9bf2-4f9bed650900/public);">
                          <div class="box-icon">
                             <i class="fas fa-hotel"></i>
                          </div>
                          <div class="icon-box-content">
                             <h3>EXTRANJERÍA</h3>
                             <!-- Photo by <a href="https://unsplash.com/@christianlue?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash">Christian Lue</a> on <a href="https://unsplash.com/photos/low-angle-photography-of-brown-historic-building-during-daytime-DTv4h2pUq-I?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash">Unsplash</a> -->
                             <!-- <app-smart-text [text]="'Con años de experiencia en la materia y un profundo entendimiento de las leyes y procedimientos españoles, nuestro equipo te proporcionará asesoramiento experto y personalizado. Desde permisos de residencia, visados de trabajo, hasta la ciudadanía española, nuestro objetivo es hacer que el proceso sea lo más suave y comprensible posible para ti'" [limit]="'150'"></app-smart-text> -->
                             <!-- <a href="javascript: void(0)" class="round-btn">Ver detalles</a> --> <!-- (click)="goToPage('service/details/0')" -->
                          </div>
                       </div>
                    </div>

                    <!-- Photo by <a href="https://unsplash.com/@wbayreuther?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash">William Bayreuther</a> on <a href="https://unsplash.com/photos/plane-wing-through-glass-window-C0KdBbibUYo?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash">Unsplash</a> -->
                    <div class="col-lg-4 col-sm-6">
                       <div class="icon-box bg-img-box" style="background-image: url(https://imagedelivery.net/_h1KjDl91qmiTNUGHVGxKQ/603e917d-fc02-44fd-254f-6c3bd54f8000/public);">
                          <div class="box-icon">
                             <i class="fas fa-plane-departure"></i>
                          </div>
                          <div class="icon-box-content">
                             <h3>BÚSQUEDA DE VUELOS</h3>
                             <!-- <p>Donec temporibus consectetuer, repudiandae integer pellentesque aliquet justo at sequi, atque quasi.</p> -->
                             <!-- <a href="javascript: void(0)" class="round-btn">Ver detalles</a> -->
                          </div>
                       </div>
                    </div>

                    <!-- Photo by <a href="https://unsplash.com/@ashkfor121?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash">Ashkan Forouzani</a> on <a href="https://unsplash.com/photos/person-in-blue-denim-jeans-with-gray-and-black-metal-padlock-ignxm3E1Rg4?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash">Unsplash</a> -->
                    <div class="col-lg-4 col-sm-6">
                       <div class="icon-box bg-img-box" style="background-image: url(https://imagedelivery.net/_h1KjDl91qmiTNUGHVGxKQ/cc35ddef-101b-4eda-c184-9320ff2a8a00/public);">
                          <div class="box-icon">
                           <i class="fas fa-heartbeat"></i>
                          </div>
                          <div class="icon-box-content">
                             <h3>SEGURO MÉDICO</h3>
                             <!-- <p>Donec temporibus consectetuer, repudiandae integer pellentesque aliquet justo at sequi, atque quasi.</p> -->
                             <!-- <a href="javascript: void(0)" class="round-btn">Ver detalles</a> -->
                          </div>
                       </div>
                    </div>
                    <div class="col-lg-4 col-sm-6">
                       <div class="icon-box bg-img-box" style="background-image: url(https://imagedelivery.net/_h1KjDl91qmiTNUGHVGxKQ/3f3a9f2b-689d-4cba-64c8-edf3dd604100/public);">
                          <div class="box-icon">
                             <i class="fas fa-file-alt"></i>
                          </div>
                          <div class="icon-box-content">
                             <h3>VISADO & TRÁMITES</h3>
                             <!-- <p>Donec temporibus consectetuer, repudiandae integer pellentesque aliquet justo at sequi, atque quasi.</p> -->
                             <!-- <a href="#" class="round-btn">Learn More</a> -->
                          </div>
                       </div>
                    </div>
                    <div class="col-lg-4 col-sm-6">
                     
                     <!-- Photo by <a href="https://unsplash.com/@ddography?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash">Deniz Demirci</a> on <a href="https://unsplash.com/photos/a-train-pulling-into-a-train-station-next-to-a-platform-8CGOpEm64FA?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash">Unsplash</a> -->
                       <div class="icon-box bg-img-box" style="background-image: url(https://imagedelivery.net/_h1KjDl91qmiTNUGHVGxKQ/d888b216-a578-4c67-2f62-f00c24c51400/public);">
                          <div class="box-icon">
                             <i class="fas fa-bus"></i>
                          </div>
                          <div class="icon-box-content">
                             <h3>GUÍA DE MOVILIDAD</h3>
                             <!-- <p>Donec temporibus consectetuer, repudiandae integer pellentesque aliquet justo at sequi, atque quasi.</p> -->
                             <!-- <a href="#" class="round-btn">Learn More</a> -->
                          </div>
                       </div>
                    </div>
                    <!-- <div class="col-lg-4 col-sm-6">
                       <div class="icon-box bg-img-box" style="background-image: url(assets/images/img10.jpg);">
                          <div class="box-icon">
                             <i class="fas fa-headset"></i>
                          </div>
                          <div class="icon-box-content">
                             <h3>SOPORTE PERSONAL</h3>
                             <p>Donec temporibus consectetuer, repudiandae integer pellentesque aliquet justo at sequi, atque quasi.</p>
                             <a href="#" class="round-btn">Learn More</a>
                          </div>
                       </div>
                    </div> -->
                    <div class="col-lg-4 col-sm-6">
                     <!-- Photo by <a href="https://unsplash.com/@dvh_mmphotography?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash">Daniel Velásquez</a> on <a href="https://unsplash.com/photos/a-tall-building-with-balconies-and-balconies-on-each-floor-Fs_o8eSJNQ8?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash">Unsplash</a> -->
                        <div class="icon-box bg-img-box" style="background-image: url(https://imagedelivery.net/_h1KjDl91qmiTNUGHVGxKQ/545ceb4f-e0fd-4ca7-a2b3-f50b58758900/public);">
                           <div class="box-icon">
                              <i class="fas fa-home"></i>
                           </div>
                           <div class="icon-box-content">
                              <h3>BÚSQUEDA DE APARTAMENTO/HABITACIÓN</h3>
                              <!-- <p>Donec temporibus consectetuer, repudiandae integer pellentesque aliquet justo at sequi, atque quasi.</p> -->
                              <!-- <a href="#" class="round-btn">Learn More</a> -->
                           </div>
                        </div>
                     </div>
                 </div>
              </div>
           </div>
           <div #packsoffer></div>
           <!-- <div class="bg-color-callback bg-light-grey">
              <div class="container">
                 <div class="row align-items-center">
                    <div class="col-lg-8 offset-lg-2 text-center">
                       <h5 class="sub-title">CALL TO ACTION</h5>
                       <h2 class="section-title">READY FOR UNFORGATABLE TRAVEL. REMEMBER US!</h2>
                       <p>Fusce hic augue velit wisi quibusdam pariatur, iusto primis, nec nemo, rutrum. Vestibulum cumque laudantium. Sit ornare mollitia tenetur, aptent.</p>
                       <div class="callback-btn">
                          <a href="contact.html" class="round-btn">Contact Us!</a>
                          <a href="about.html" class="outline-btn">Learn More</a>
                       </div>
                    </div>
                 </div>
              </div>
           </div> -->
           <!-- ***callback section html end here*** -->
        </section>
     </main>
     
       <!-- site header html end  -->
       <main id="content" class="site-main">

          <!-- ***search search field html end here*** -->
          <!-- ***Home destination html start from here*** -->

          <!-- ***Home destination html end here*** -->
          <!-- ***Home package html start from here*** -->
         
          <app-product-offer></app-product-offer>

          <app-webapp-banner></app-webapp-banner>
          
          <app-package-offer></app-package-offer>
          <!-- ***Home package html end here*** -->
          <!-- ***Home callback html start from here*** -->
          <!-- <section class="home-callback bg-img-fullcallback" style="background-image: url(assets/images/img7.jpg);">
             <div class="overlay"></div>
             <div class="container">
                <div class="row">
                   <div class="col-lg-8 offset-lg-2 text-center">
                      <div class="callback-content">
                         <div class="video-button">
                            <a  id="video-container" data-fancybox="video-gallery" href="https://www.youtube.com/watch?v=2OYar8OHEOU">
                               <i class="fas fa-play"></i>
                            </a>
                         </div>
                         <h2 class="section-title">TU PUENTE HACIA NUEVAS EXPERIENCIAS EN EUROPA!</h2>
                         <p>Fusce hic augue velit wisi quibusdam pariatur, iusto primis, nec nemo, rutrum. Vestibulum cumque laudantium. Sit ornare mollitia tenetur, aptent.</p>
                         <div class="callback-btn">
                            <a href="package.html" class="round-btn">View Packages</a>
                            <a href="about.html" class="outline-btn outline-btn-white">Learn More</a>
                         </div>
                      </div>
                   </div>
                </div>
             </div>
          </section> -->
          <!-- ***Home callback html end here*** -->
          <!-- ***Home counter html start from here*** -->
          <!-- <div class="home-counter">
             <div class="container">
                <div class="counter-wrap">
                   <div class="counter-item">
                      <span class="counter-no">
                         <span class="counter">80</span>K+
                      </span>
                      <span class="counter-desc">
                         SATISFIED CUSTOMER
                      </span>
                   </div>
                   <div class="counter-item">
                      <span class="counter-no">
                         <span class="counter">18</span>+
                      </span>
                      <span class="counter-desc">
                         ACTIVE MEMBERS
                      </span>
                   </div>
                   <div class="counter-item">
                      <span class="counter-no">
                         <span class="counter">220</span>+
                      </span>
                      <span class="counter-desc">
                         TOUR DESTINATION
                      </span>
                   </div>
                   <div class="counter-item">
                      <span class="counter-no">
                         <span class="counter">75</span>+
                      </span>
                      <span class="counter-desc">
                         TRAVEL GUIDES
                      </span>
                   </div>
                </div>
             </div>
          </div> -->
          <!-- ***Home counter html end here*** -->
          <!-- ***Home offer html start from here*** -->
          <!-- <section class="home-offer">
             <div class="container">
                <div class="row">
                   <div class="col-lg-8 offset-lg-2 text-sm-center">
                      <div class="section-heading">
                         <h5 class="sub-title">OFFER & DISCOUNT</h5>
                         <h2 class="section-title">OUR SPECIAL PACKAGES</h2>
                         <p>Fusce hic augue velit wisi quibusdam pariatur, iusto primis, nec nemo, rutrum. Vestibulum cumque laudantium. Sit ornare mollitia tenetur, aptent.</p>
                      </div>
                   </div>
                </div>
                <div class="offer-section">
                   <div class="row">
                      <div class="col-md-6">
                         <article class="offer-item" style="background-image: url(assets/images/img8.jpg);">
                            <div class="offer-badge">
                               UPTO <span>25%</span> off
                            </div>
                            <div class="offer-content">
                               <div class="package-meta">
                                  <ul>
                                     <li>
                                        <i class="fas fa-clock"></i>
                                        7D/6N
                                     </li>
                                     <li>
                                        <i class="fas fa-user-friends"></i>
                                        pax: 10
                                     </li>
                                     <li>
                                        <i class="fas fa-map-marker-alt"></i>
                                        Malaysia
                                     </li>
                                  </ul>
                               </div>
                               <h3>
                                  <a href="package.html">TOUR TO SATORINI</a>
                               </h3>
                               <p>
                                  Fusce hic augue velit wisi ips quibus dam pariatur, iusto.
                               </p>
                               <div class="price-list">
                                  price: 
                                  <del>$1300 </del>
                                  <ins>$1105</ins>
                               </div>
                               <a href="booking.html" class="round-btn">Book Now</a>
                            </div>
                         </article>
                      </div>
                      <div class="col-md-6">
                         <article class="offer-item" style="background-image: url(assets/images/img9.jpg);">
                            <div class="offer-badge">
                               UPTO <span>17%</span> off
                            </div>
                            <div class="offer-content">
                               <div class="package-meta">
                                  <ul>
                                     <li>
                                        <i class="fas fa-clock"></i>
                                        5D/4N
                                     </li>
                                     <li>
                                        <i class="fas fa-user-friends"></i>
                                        pax: 10
                                     </li>
                                     <li>
                                        <i class="fas fa-map-marker-alt"></i>
                                        Malaysia
                                     </li>
                                  </ul>
                               </div>
                               <h3>
                                  <a href="package.html">WEEKEND TO PARIS</a>
                               </h3>
                               <p>
                                  Fusce hic augue velit wisi ips quibus dam pariatur, iusto.
                               </p>
                               <div class="price-list">
                                  price: 
                                  <del>$1100 </del>
                                  <ins>$900</ins>
                               </div>
                               <a href="booking.html" class="round-btn">Book Now</a>
                            </div>
                         </article>
                      </div>
                   </div>
                   <div class="section-btn-wrap text-center">
                      <a href="package-offer.html" class="round-btn">VIEW ALL PACKAGES</a>
                   </div>
                </div>
             </div>
          </section> -->
          <!-- ***Home offer html end here*** -->

          <!-- ***Home testimonial html end here*** -->
          <!-- ***Home callback html start from here*** -->
          <section class="home-callback bg-color-callback primary-bg">
             <div class="container">
                <div class="row align-items-center">
                   <div class="col-md-8">
                      <h5 class="sub-title">RESERVA TU VIDEOLLAMADA GRATUITA Y </h5>
                      <h2 class="section-title">COMENCEMOS A PLANEAR TU AVENTURA!!</h2>
                      <p>Fusce hic augue velit wisi quibusdam pariatur, iusto primis, nec nemo, rutrum. Vestibulum cumque laudantium. Sit ornare mollitia tenetur, aptent.</p>
                   </div>
                   <div class="col-md-4 text-md-end">
                      <a href="javascript:void(0)" (click)="goToCalendly()" class="outline-btn outline-btn-white">RESERVAR VIDEOLLAMADA</a>
                   </div>
                </div>
             </div>
          </section>
          <!-- ***Home callback html end here*** -->
       </main>
       <!-- ***site footer html start form here*** -->
       <app-smart-footer></app-smart-footer>

       <!-- ***site footer html end*** -->
       <a id="backTotop" href="#" class="to-top-icon">
          <i class="fas fa-chevron-up"></i>
       </a>
       <!-- ***custom search field html*** -->
       <div class="header-search-form">
          <div class="container">
             <div class="header-search-container">
                <form class="search-form" role="search" method="get" >
                   <input type="text" name="s" placeholder="Enter your text...">
                </form>
                <a href="#" (click)="goToPage('home')" class="search-close">
                   <i class="fas fa-times"></i>
                </a>
             </div>
          </div>
       </div>
       <!-- ***custom search field html*** -->
       <!-- ***custom top bar offcanvas html*** -->
       <div id="offCanvas" class="offcanvas-container">
          <div class="offcanvas-inner">
             <div class="offcanvas-sidebar">
                <aside class="widget author_widget">
                   <h3 class="widget-title">OUR PROPRIETOR</h3>
                   <div class="widget-content text-center"> 
                      <div class="profile"> 
                         <figure class="avatar"> 
                            <img src="assets/images/img21.jpg" alt=""> 
                         </figure> 
                         <div class="text-content"> 
                            <div class="name-title"> 
                               <h4> James Watson</h4> 
                            </div> 
                            <p>Accumsan? Aliquet nobis doloremque, aliqua? Inceptos voluptatem, duis tempore optio quae animi viverra distinctio cumque vivamus, earum congue, anim velit</p> 
                         </div> 
                         <div class="socialgroup"> 
                            <ul> 
                               <li> <a target="_blank" href="#"> <i class="fab fa-facebook"></i> </a> </li> 
                               <li> <a target="_blank" href="#"> <i class="fab fa-google"></i> </a> </li> 
                               <li> <a target="_blank" href="#"> <i class="fab fa-twitter"></i> </a> </li> 
                               <li> <a target="_blank" href="#"> <i class="fab fa-instagram"></i> </a> </li> 
                               <li> <a target="_blank" href="#"> <i class="fab fa-pinterest"></i> </a> </li> 
                            </ul> 
                         </div> 
                      </div> 
                   </div>
                </aside>
                <aside class="widget widget_text text-center">
                   <h3 class="widget-title">CONTACT US</h3>
                   <div class="textwidget widget-text">
                      <p>Feel free to contact and<br/> reach us !!</p>
                      <ul>
                         <li>
                            <a href="tel:+01988256203">
                               <i aria-hidden="true" class="icon icon-phone1"></i>
                               +01(988) 256 203
                            </a>
                         </li>
                         <li>
                            <a href="mailtop:info@domain.com">
                               <i aria-hidden="true" class="icon icon-envelope1"></i>
                               info@domain.com
                            </a>
                         </li>
                         <li>
                            <i aria-hidden="true" class="icon icon-map-marker1"></i>
                            3146 Koontz, California
                         </li>
                      </ul>
                   </div>
                </aside>
             </div>
             <a href="#" (click)="goToPage('home')" class="offcanvas-close">
                <i class="fas fa-times" (click)="goToPage('home')"></i>
             </a>
          </div>
          <div class="overlay"></div>
       </div>
       <!-- ***custom top bar offcanvas html*** -->
    </div>

  
 </body>